module.exports = __webpack_public_path__ + "img/team.0bc77b86.png";